import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/MoreVert';
import Divider from '@material-ui/core/Divider';
import { fontFamily, fontSize } from '../../../constants/text';
import { colors } from '../../../constants/colors';
import { getSmsSeparator, isAndroidOS, isIOS } from '../../../core/util/device';
import { setHideAddToHomeScreenPopUpCookie } from '../../AddToHomeScreenPopUp/util';
import {
  BURGER_MENU_TOUCH_HELP,
  campaignNames,
  DOWNLOAD_DRIVER_CLICK_LINK,
  HEADER_V2_TOGGLE_DRAWER,
} from '../../../core/analytics/events';
import { analyticsTrackEvent } from '../../../core/analytics';
import { SAVE_SOLV_PATH } from '../../../constants/index';
import { BASE_URL, HELP_BASE_URL } from '../../../config/index';
import { setRuntimeVariable } from '../../../actions/runtime';
import { isMobile } from '../../../core/util/device';
import { getNativeStoreDownloadLink } from '../../DownloadDriver/util';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: any) => ({
  showAddToHomeScreenPopUp: () =>
    dispatch(setRuntimeVariable({ name: 'showAddToHomeScreenPopUp', value: true })),
});

const StyledListItem = styled(MenuItem)`
  color: ${colors.squid};
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.medium};
  padding: 8px 24px;
`;

const SecondaryListItem = styled(MenuItem)`
  color: ${colors.lightText};
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.medium};
  padding: 8px 24px;

  a,
  a:visited {
    text-decoration: none;
    color: ${colors.lightText};
  }
`;

const StyledDivider = styled(Divider)`
  margin: 8px 0;
`;

const StyledMenuIcon = styled(MenuIcon)`
  cursor: pointer;
  font-size: ${fontSize.extraLarge};
  align-items: center;
  color: ${colors.squid};
`;

type LoggedOutMenuProps = {
  showAddToHomeScreenPopUp?: (...args: any[]) => any;
  openLogInModal?: (...args: any[]) => any;
  openSignUpModal?: (...args: any[]) => any;
};

type LoggedOutMenuState = any;

class LoggedOutMenu extends Component<LoggedOutMenuProps, LoggedOutMenuState> {
  state = {
    anchorEl: null,
  };

  handleClick = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
    analyticsTrackEvent(HEADER_V2_TOGGLE_DRAWER, {
      isMobile: isMobile(),
      isLoggedIn: false,
      transitionToState: 'open',
    });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
    analyticsTrackEvent(HEADER_V2_TOGGLE_DRAWER, {
      isMobile: isMobile(),
      isLoggedIn: false,
      transitionToState: 'close',
    });
  };

  handleSaveSolvOnClick = () => {
    if (isAndroidOS() || isIOS()) {
      const campaignName = campaignNames.LOGGED_OUT_MENU;
      analyticsTrackEvent(DOWNLOAD_DRIVER_CLICK_LINK, { campaignName, url: window.location });
      window.location.href = getNativeStoreDownloadLink(campaignName);
    } else {
      window.location.href = `${BASE_URL}${SAVE_SOLV_PATH}`;
    }
  };

  handleHelpOnClick = () => {
    analyticsTrackEvent(BURGER_MENU_TOUCH_HELP, { isMobile: isMobile() });
    window.location.href = HELP_BASE_URL;
  };

  render() {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const { openSignUpModal, openLogInModal } = this.props;

    return (
      <div>
        <StyledMenuIcon onClick={this.handleClick} />

        <Menu anchorEl={anchorEl} onClose={this.handleClose} open={open}>
          <StyledListItem onClick={this.handleHelpOnClick}>Help</StyledListItem>

          <StyledListItem data-testid="login-header-button" onClick={openLogInModal}>
            Log In
          </StyledListItem>

          <StyledListItem data-testid="signup-header-button" onClick={openSignUpModal}>
            Sign Up
          </StyledListItem>
          {isMobile() && (
            <div>
              <StyledDivider light />

              <SecondaryListItem onClick={this.handleSaveSolvOnClick}>
                Download app
              </SecondaryListItem>

              <SecondaryListItem>
                <a
                  href={
                    `sms://${getSmsSeparator()}body=Hey, you should check out Solv! ` +
                    "You can book a same-day doctor's appointment at a place that takes your " +
                    'insurance. ' +
                    'Super fast and free to book. http://solv.me/share/nav'
                  }
                >
                  Share
                </a>
              </SecondaryListItem>
            </div>
          )}
        </Menu>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoggedOutMenu);
